import { Edge, Node } from 'react-flow-renderer';

export const DeleteTrigger = (data: any, id: string) => () => {
    data.setNodes((nodes: Node[]) => nodes.filter((el) => el.type !== 'trigger' && el.type !== 'webhook' && el.type !== 'schedule'));
    data.setEdges((edges: Edge[]) => []);
};
